const DEFAULT = 'en';
function getBrowserLocale() {
    if (navigator.languages) return navigator.languages[0];
    else if (navigator.userLanguage) return navigator.userLanguage;
    return navigator.language;
  }
  
  function getPrefferedLocal(browserLocale,supportedTranslations){
    return supportedTranslations.get(browserLocale)
    ? browserLocale
    : supportedTranslations.get(browserLocale.slice(0,2))
        ? browserLocale.slice(0,2) 
        : DEFAULT;
  }
  
  
  export  {getBrowserLocale,getPrefferedLocal}